import {
  PartnerFeatureEnum,
  OrganizationPartnershipLevelEnum,
} from "@/__generated__/types";
import type { RouteId } from "@/routes/getRoute";

/**
 * Maps route identifiers to their required feature flags
 * Add new routes here when they need feature protection
 */
export const FEATURE_PROTECTED_ROUTES: Partial<
  Record<RouteId, PartnerFeatureEnum>
> = {
  createBulkMessage: PartnerFeatureEnum.BulkMessaging,
  bulkMessageCompose: PartnerFeatureEnum.BulkMessaging,
  editBulkMessaging: PartnerFeatureEnum.BulkMessaging,
  editBulkMessagingCompose: PartnerFeatureEnum.BulkMessaging,
  editGame: PartnerFeatureEnum.Games,
  strategy: PartnerFeatureEnum.Rise,
  rise: PartnerFeatureEnum.Rise,
  applyIndex: PartnerFeatureEnum.RisePredictiveModels,
  meltIndex: PartnerFeatureEnum.RisePredictiveModels,
  yieldIndex: PartnerFeatureEnum.RisePredictiveModels,
  retainIndex: PartnerFeatureEnum.RisePredictiveModels,
  impact: PartnerFeatureEnum.Rise,
};

/**
 * Maps route identifiers to their required partnership levels
 * Add new routes here when they need partnership level protection
 */
export const PARTNERSHIP_PROTECTED_ROUTES: Partial<
  Record<RouteId, OrganizationPartnershipLevelEnum>
> = {
  students: OrganizationPartnershipLevelEnum.Pro,
  student: OrganizationPartnershipLevelEnum.Pro,
  funnel: OrganizationPartnershipLevelEnum.Pro,
  predictiveModels: OrganizationPartnershipLevelEnum.Pro,
  commitIndex: OrganizationPartnershipLevelEnum.Pro,
};
